import { render, staticRenderFns } from "./SupplierKYCForm.vue?vue&type=template&id=05af1522&"
import script from "./SupplierKYCForm.vue?vue&type=script&lang=js&"
export * from "./SupplierKYCForm.vue?vue&type=script&lang=js&"
import style0 from "./SupplierKYCForm.vue?vue&type=style&index=0&id=05af1522&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05af1522')) {
      api.createRecord('05af1522', component.options)
    } else {
      api.reload('05af1522', component.options)
    }
    module.hot.accept("./SupplierKYCForm.vue?vue&type=template&id=05af1522&", function () {
      api.rerender('05af1522', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/requests/detailPages/supplierDetailPages/SupplierKYCForm.vue"
export default component.exports